import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'
import type { TimelineEntryKind, TimelineResponse } from '@/lib/types'

export function useTimeline(
  contactId: string | undefined,
  page = 1,
  filter: TimelineEntryKind | 'all' = 'all',
) {
  const params = new URLSearchParams({ page: String(page), limit: '20' })
  if (filter !== 'all') params.set('filter', filter)

  return useQuery({
    queryKey: ['timeline', contactId, page, filter],
    queryFn: () => api<TimelineResponse>(`/api/contacts/${contactId}/timeline?${params}`),
    enabled: !!contactId,
  })
}
